export default function copy() {
    const elements = document.querySelectorAll('.js-copy');

    if (!elements) return;

    elements.forEach((element) => {
        element.addEventListener('click', () => {
            const {copyText} = element.dataset;
            copyToClipboard(copyText);
        });
    });

    function copyToClipboard(text) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text);
        } else {
            const element = document.createElement('textarea');
            element.value = text;
            document.body.appendChild(element);
            element.select();
            element.setSelectionRange(0, 99999);
            document.execCommand('copy');
            document.body.removeChild(element);
        }
    }
};
